// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__XwMsa","filesListContainer":"PosDisputesFiles_filesListContainer__2npIU","filesButton":"PosDisputesFiles_filesButton__303t5"};